import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/LawDisplayPage.css';

const LabourLaw = () => {
  const navigate = useNavigate();
  const buttonContainerRef1 = useRef(null);
  const buttonContainerRef2 = useRef(null);

  const scrollLeft = (ref) => {
    ref.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = (ref) => {
    ref.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="law-page">
      {/* Heading */}
      <h1>Indian Labour Law</h1>

      {/* Details of Indian Labour Law */}
      <div className="content-section">
        <h2>Details of Indian Labour Law</h2>
        <p>
          Indian Labour Law governs the relationship between employers, employees, and trade unions. It ensures fair treatment,
          safe working conditions, timely wages, social security, and rights to form unions or raise disputes.
        </p>
        <p>
          In recent years, the Government of India has consolidated 29 central labour laws into four comprehensive codes to simplify compliance and
          improve labour welfare. These laws apply across industries and sectors to ensure transparency and accountability.
        </p>
      </div>

      {/* First Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef1)} />
        <div className="button-container" ref={buttonContainerRef1}>
          <button className="big-button">Code on Wages, 2019</button>
          <button className="big-button">Code on Social Security, 2020</button>
          <button className="big-button">Industrial Relations Code, 2020</button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef1)} />
      </div>

      {/* Second Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef2)} />
        <div className="button-container" ref={buttonContainerRef2}>
          <button className="big-button">Occupational Safety, Health & Working Conditions Code, 2020</button>
          <button className="big-button">Contract Labour Regulation</button>
          <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef2)} />
      </div>
    </div>
  );
};

export default LabourLaw;
